'use client';

import { getTextRarityClass, tw } from '../../utils';

interface RarityTextProps {
  rarity: string;
  size?: 'small' | 'medium' | 'large';
  weight?: 'normal' | 'medium' | 'semibold' | 'bold';
  className?: string;
  children: React.ReactNode;
}

const weightClasses = {
  normal: 'font-normal',
  medium: 'font-medium',
  semibold: 'font-semibold',
  bold: 'font-semibold',
};

const sizeClasses = {
  small: 'text-xs',
  medium: 'text-sm',
  large: 'text-lg',
};

export const RarityText: React.FC<RarityTextProps> = ({
  rarity,
  children,
  size = 'large',
  weight = 'normal',
  className,
}: RarityTextProps) => {
  return (
    <p
      className={tw(
        getTextRarityClass(rarity),
        'w-max capitalize tracking-wider',
        sizeClasses[size],
        weightClasses[weight],
        className,
      )}
    >
      {children}
    </p>
  );
};
